<template>
  <!-- <el-header class="v-header">
    <img class="navLogo" :src="require('@/assets/images/logoicollege.png')" alt />
    <el-menu  v-if="menuVal"
              :default-active="activeIndex"
              id="el-menu-header"
              mode="horizontal"
              @select="handleSelect"
              background-color="#fff"
              text-color="#545c64"
              active-text-color="#409eff"
              router
              class="navMenu">
      <div  v-for="(item,i) in menuVal.navMenu" :key="i" class="menuOne">
        <el-menu-item :index="newSrc(i,item.pageid)" 
                      :key="i" v-if="item.childmenus==null" >{{item.name}}</el-menu-item>
        <el-submenu :index="newSrc(i,item.pageid)" v-else>
          <template slot="title">{{item.name}}</template>
          <div class="er" :key="j" v-for="(val,j) in item.childmenus">
            <el-menu-item :index="newSrc(i,val.pageid)"  v-if="val.childmenus==null">{{val.name}}</el-menu-item>
            <el-submenu  v-else>
              <template slot="title" :index="newSrc(i,val.pageid)">{{item.name}}</template>
              <el-menu-item :index="newSrc(i,val.pageid)" :key="k" v-for="(val,k) in val.childmenus">{{val.name}}</el-menu-item>
            </el-submenu>
          </div>
        </el-submenu>
        </div>
    </el-menu>
  </el-header> -->
  <el-header class="v-header">
    <img class="navLogo" :src="require('@/assets/images/logo-college-black.png')" alt/>
    <ul class="myNav">
        <!-- level1 -->
        <li :class="menuActive(item)"    
            v-for="(item,i) in menuVal.navMenu"
            :key=i > 
            <a v-if="item.childmenus==null" :href="newSrc(i,item.pageid)">{{item.name}}</a>
            <span v-else @mouseover="mouseOver"  @mouseleave="mouseLeave">
              {{item.name}}
              <!-- <i v-if="item.childmenus!==null" :style="myIcon"  class="myArrow"></i> -->
              <img  v-if="item.childmenus!==null" class="myArrow" :src="myIcon" alt />
              <!-- level2 -->
              <ul class="menuBox">
                <li class="menulevel2" :key="j" v-for="(val,j) in item.childmenus">
                  <a :href="newSrc(i,val.pageid)">{{val.name}}</a> 
                </li>
              </ul>
            </span>
        </li>
    </ul>
    <!-- <div class="links-zone">
      <div class="links">
        <a class="link" href="/index" :class="{active:activeTab===0}">首页</a>
      </div>
      <div class="links">
        <div class="link-module" :class="{active:activeTab===1}" hover-class="hover">
          校企共建<div class="arrow"></div>
          <div class="link-list">
            <a class="link-item" href="/build/?id=P20092115191903">人才培养</a>
            <a class="link-item" href="/build/?id=P20092217361003">学院共建</a>
            <a class="link-item" href="/build/?id=P20092217364103">产学合作协同育人</a>
          </div>
        </div>
      </div>
      <div class="links">
        <div class="link-module" :class="{active:activeTab===2}" hover-class="hover">
          智慧校园<div class="arrow"></div>
          <div class="link-list">
            <a class="link-item" href="/build/?id=P20092217371703">实验室解决方案</a>
            <a class="link-item" href="/build/?id=P20092217380303">智慧教育平台</a>
            <a class="link-item" href="/newbuild/?id=P20092217383603">智慧校园解决方案</a>
          </div>
        </div>
      </div>
      <div class="links">
        <div class="link-module" :class="{active:activeTab===3}" hover-class="hover">
          职业教育<div class="arrow"></div>
          <div class="link-list">
            <a class="link-item" href="/build/?id=P20092217393203">学历技能双提升</a>
          </div>
        </div>
      </div>
      <div class="links">
        <div class="link-module" :class="{active:activeTab===4}" hover-class="hover">
          认证与考试<div class="arrow"></div>
          <div class="link-list">
            <a class="link-item" href="/build/?id=P20092217403703">华为认证</a>
          </div>
        </div>
      </div>
      <div class="links">
        <div class="link-module" :class="{active:activeTab===5}" hover-class="hover">
          企业服务<div class="arrow"></div>
          <div class="link-list">
            <a class="link-item" href="/build/?id=P20092217410503">企业内训</a>
            <a class="link-item" href="/build/?id=P20092217414203">高精尖产业技能培训</a>
          </div>
        </div>
      </div>
      <div class="links">
        <div class="link-module" :class="{active:activeTab===6}" hover-class="hover">
          校园招聘<div class="arrow"></div>
          <div class="link-list">
            <a class="link-item" href="/newbuild/?id=P20092217421303">校园招聘</a>
          </div>
        </div>
      </div>
      <div class="links">
        <div class="link-module" :class="{active:activeTab===7}" hover-class="hover">
          合作案例<div class="arrow"></div>
          <div class="link-list">
            <a class="link-item" href="/build/?id=P20092217443303">合作案例</a>
          </div>
        </div>
      </div>
      <div class="links">
        <div class="link-module" :class="{active:activeTab===8}" hover-class="hover">
          关于我们<div class="arrow"></div>
          <div class="link-list">
            <a class="link-item" href="/newbuild/?id=P20092217533003">公司简介</a>
            <a class="link-item" href="/build/?id=P20092217541802">新闻动态</a>
            <a class="link-item" href="/build/?id=P20092217545403">师资团队</a>
            <a class="link-item" href="/build/?id=P20092217551803">联系我们</a>
          </div>
        </div>
      </div>
    </div> -->
  </el-header>
</template>

<script>
export default {
  name: "v-header",
  props: {
      menuVal: null //这样可以指定传入的类型，如果类型不对，会警告
  },
  data() {
    return {
      activeIndex: "0",
      newbuildList:[
        {"id":"P20092217383603","name":"智慧校园--智慧校园解决方案"},
        {"id":"P20092217421303","name":"校园招聘--校园招聘"},
        {"id":"P20092217533003","name":"关于我们--公司简介"}
      ],//新静态页面列表
      myIcon:require('@/assets/images/nav-arrow-down.png'),//iconstyle
      nowPageId:"",//当前page的id
    };
  },
  created() {
    // console.log("menuVal",this.menuVal);
    var that = this;
    that.nowPageId =  that.$route.query.id;
    console.log("transform: rotate(180deg);",that.$route);
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      // this.activeIndex = key;
    },
    numberToString(_data){
      return (_data+1).toString();
    },
    //定义路由地址Url
    newSrc(_i,_pageId){
      //_i==0 首页
      //_pageId 页面id
      var that = this;
      for(var i=0;i<that.newbuildList.length;i++){
        // debugger;
        if(that.newbuildList[i].id== _pageId){
          return '/newbuild/?id='+_pageId;
        }
      }
      if(_i==0){
        return '/index';
      }else{
        return '/build/?id='+_pageId;
      }
    },
   //菜单激活状态
   menuActive(_item){
     var that = this;
     
     if(_item.pageid == that.nowPageId){
       return "menulevel1 active";
     }
    //  debugger;
     if(_item.childmenus!==null){
       for(var i=0;i<_item.childmenus.length;i++){
        if(_item.childmenus[i].pageid == that.nowPageId){
            return "menulevel1 active";
        }
      }
     }
     return "menulevel1";
   },
   //鼠标移入移出增加下拉箭头
    mouseOver: function(){
        this.myIcon =require('@/assets/images/nav-arrow-down-red.png');
    },
    mouseLeave: function () {
        this.myIcon =require('@/assets/images/nav-arrow-down.png');
   },
  },
};
</script>

<style lang="scss">

</style>
